import styled, { css } from 'styled-components';

import responsive from 'theme/responsive';

import PropertyList from './PropertyList';

const StyledPropertyList = styled(PropertyList)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;

    ${responsive.sm(css`
        grid-template-columns: 1fr 1fr 1fr;
    `)}

    .property-list-card:nth-of-type(1n+3) {
        display: none;

        ${responsive.sm(css`
            display: block;
        `)}
    }
`;

export default StyledPropertyList;
